/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateEtcCardLabel200ResponseHolder } from './update-etc-card-label200-response-holder';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateEtcCardLabel200ResponseUserAccountGroup } from './update-etc-card-label200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateEtcCardLabel200Response
 */
export interface UpdateEtcCardLabel200Response {
    /**
     * ETC card ID
     * @type {string}
     * @memberof UpdateEtcCardLabel200Response
     */
    'cardId': string;
    /**
     * Card name (max 64 characters)
     * @type {string}
     * @memberof UpdateEtcCardLabel200Response
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof UpdateEtcCardLabel200Response
     */
    'cardStatus': UpdateEtcCardLabel200ResponseCardStatusEnum;
    /**
     * 
     * @type {UpdateEtcCardLabel200ResponseHolder}
     * @memberof UpdateEtcCardLabel200Response
     */
    'holder': UpdateEtcCardLabel200ResponseHolder;
    /**
     * 
     * @type {UpdateEtcCardLabel200ResponseUserAccountGroup}
     * @memberof UpdateEtcCardLabel200Response
     */
    'userAccountGroup'?: UpdateEtcCardLabel200ResponseUserAccountGroup | null;
    /**
     * User account ID
     * @type {string}
     * @memberof UpdateEtcCardLabel200Response
     */
    'userAccountId': string;
    /**
     * Last four digits of the ETC card ID for display
     * @type {string}
     * @memberof UpdateEtcCardLabel200Response
     */
    'etcIdLastFourDigits'?: string | null;
}

export const UpdateEtcCardLabel200ResponseCardStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type UpdateEtcCardLabel200ResponseCardStatusEnum = typeof UpdateEtcCardLabel200ResponseCardStatusEnum[keyof typeof UpdateEtcCardLabel200ResponseCardStatusEnum];


